module.exports = __webpack_public_path__ + "img/ico-home.8fb8a480.svg";